// extracted by mini-css-extract-plugin
export default {"root":"river-sidebar-logo_root__WdqgJ","logo-image":"river-sidebar-logo_logo-image__KzAG+"};